import { useState, useEffect } from 'react';

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: 0, // Initial value doesn't use window object
    height: 0,
  });

  useEffect(() => {
    // Function to update the state with current window dimensions
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Initial call to set the window dimensions
    handleResize();

    // Add event listener for resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener when component unmounts
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures this effect runs once after component mounts

  return windowDimensions;
};

export default useWindowDimensions;
